import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/battery-charging.vue
var o = {
	name: "DtIconBatteryCharging",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--battery-charging"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Battery Charging",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M5.757 3.071a.5.5 0 0 1 .172.686L4.883 5.5H6a.5.5 0 0 1 .429.757l-1.5 2.5a.5.5 0 0 1-.858-.514L5.117 6.5H4a.5.5 0 0 1-.429-.757l1.5-2.5a.5.5 0 0 1 .686-.172ZM.94 3.44A1.5 1.5 0 0 1 2 3h1a.5.5 0 0 1 0 1H2a.5.5 0 0 0-.5.5v3A.5.5 0 0 0 2 8h.5a.5.5 0 0 1 0 1H2A1.5 1.5 0 0 1 .5 7.5v-3c0-.398.158-.78.44-1.06ZM7 3.5a.5.5 0 0 1 .5-.5H8a1.5 1.5 0 0 1 1.5 1.5v3A1.5 1.5 0 0 1 8 9H7a.5.5 0 1 1 0-1h1a.5.5 0 0 0 .5-.5v-3A.5.5 0 0 0 8 4h-.5a.5.5 0 0 1-.5-.5ZM11 5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0v-1A.5.5 0 0 1 11 5Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=battery-charging.js.map